import React from 'react'
import { useTranslation } from 'react-i18next'
import { WidgetGuard } from 'features/types'
import { useDashboardWidgetSetting } from 'hooks/useDashboardState'
import ErrorMessage from 'components/share/ErrorMessage'
import { CrosstabWidgetsType } from '../../types'
import { MAX_CELLS } from '../constants'
import { getWidgetSettingConfig, getRowData, getColumnData } from '../utils/crosstabDataUtils'

const CrosstabOverComplexityGuard: WidgetGuard = ({ widgetId, children }) => {
  const widgetSetting = useDashboardWidgetSetting<CrosstabWidgetsType>(widgetId)
  const { displayRowGrandTotal } = getWidgetSettingConfig(widgetSetting)
  const { t } = useTranslation()

  const { rowIds } = getRowData(widgetSetting)
  const { columnIds } = getColumnData(widgetSetting, false)

  const searchComplexity = rowIds.length * (columnIds.length - Number(displayRowGrandTotal))
  if (searchComplexity > MAX_CELLS) {
    return <ErrorMessage>{t('crosstabOverComplexity')}</ErrorMessage>
  }

  return children
}

export default CrosstabOverComplexityGuard
